/*!
 * Views Registry - Registre et fabrique des vues pour IconsView
 */

import BaseView from './BaseView';
import CardView from './CardView';
import CardsView from './CardsView';
import TableView from './TableView';
import TreeView from './TreeView';
import BlocksView from './BlocksView';
import MosaicView from './MosaicView';
import IconsViewMode from './IconsViewMode';
import ListView from './ListView';
import ThumbnailsView from './ThumbnailsView';
import SlideshowView from './SlideshowView';
import SummaryView from './SummaryView';
import PreviewView from './PreviewView';
import CalendarView from './CalendarView';
import KanbanView from './KanbanView';
import TimelineView from './TimelineView';
import MapView from './MapView';
import CheatsheetView from './CheatsheetView';
import AccordionView from './AccordionView';

const viewRegistry = {
    table: TableView,
    cards: CardsView,
    card: CardsView,
    tree: TreeView,
    accordion: AccordionView,
    blocks: BlocksView,
    mosaic: MosaicView,
    icons: IconsViewMode,
    list: ListView,
    thumbnails: ThumbnailsView,
    thumbs: ThumbnailsView,
    slideshow: SlideshowView,
    summary: SummaryView,
    preview: PreviewView,
    calendar: CalendarView,
    'calendar-week': CalendarView,
    'calendar-day': CalendarView,
    kanban: KanbanView,
    timeline: TimelineView,
    map: MapView,
    cheatsheet: CheatsheetView,
};

/**
 * Enregistre une nouvelle classe de vue dans le système.
 * @param {String} name - Nom de la vue
 * @param {Function} ViewClass - Classe héritant de BaseView
 */
export function registerView(name, ViewClass) {
    viewRegistry[name] = ViewClass;
}

/**
 * Récupère la classe de vue associée au nom demandé.
 * @param {String} name - Nom de la vue
 * @returns {Function}
 */
export function getViewClass(name) {
    return viewRegistry[name] || MosaicView;
}

/**
 * Instancie la vue demandée pour le plugin IconsView donné.
 * @param {String} name - Nom de la vue
 * @param {IconsView} plugin - Instance du plugin IconsView
 * @returns {BaseView}
 */
export function createViewInstance(name, plugin) {
    const ViewClass = getViewClass(name);
    return new ViewClass(plugin, name);
}

export {
    BaseView,
    CardView,
    CardsView,
    TableView,
    TreeView,
    BlocksView,
    MosaicView,
    IconsViewMode,
    ListView,
    ThumbnailsView,
    SlideshowView,
    SummaryView,
    PreviewView,
    CalendarView,
    KanbanView,
    TimelineView,
    MapView,
    CheatsheetView,
    AccordionView,
    viewRegistry,
};
